import { render, staticRenderFns } from "./HorizontalScroll.vue?vue&type=template&id=d08917ec&scoped=true"
import script from "./HorizontalScroll.vue?vue&type=script&lang=js"
export * from "./HorizontalScroll.vue?vue&type=script&lang=js"
import style0 from "./HorizontalScroll.vue?vue&type=style&index=0&id=d08917ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08917ec",
  null
  
)

export default component.exports